import { render, staticRenderFns } from "./leaveRequestModal.vue?vue&type=template&id=67d04218&"
import script from "./leaveRequestModal.vue?vue&type=script&lang=js&"
export * from "./leaveRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./leaveRequestModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports